import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { Controller } from '@commoncore/controller/Controller';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { AddToAlbumImplementation } from '@core/implementation/addToAlbumImplementation';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';

export class addToAlbumController extends Controller{
    public fileOperationsImplementation:any;
    public addtoAlbumImplementatoin:any;
    public universalService:any;
    public router:any;
    public http:any;
    public static singleInstance:any = null;
    public fileOpsController:any;
  loggerService: any;
  listService:any;
     

    public constructor(public globalService:GlobalService) {
      super(globalService);
      this.fileOperationsImplementation= FileOperationsImplementation.getInstance(globalService);
      this.addtoAlbumImplementatoin = AddToAlbumImplementation.getInstance(globalService);
    }
    
    public static getInstance(globalService):addToAlbumController{
		if(this.singleInstance == null){
			this.singleInstance = new addToAlbumController(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}


    public setEnvObjects(globalService){
		this.universalService=globalService.getUniversalServiceRef();
		this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();   
    this.fileOpsController = FileOperationsController.getInstance(globalService);
    this.loggerService = globalService.getLoggerServiceRef();
    this.listService = globalService.getListServiceRef();
    }


   async  setFileDataForAddToAlbum(files){     
      this.addtoAlbumImplementatoin.setHandler(this.globalService);
      this.addtoAlbumImplementatoin.setRequiredDataForAddingtoAlbum(files);
      try{
        var result = await this.addtoAlbumImplementatoin.loadDataForAddingToAlbum(files);
      }catch(exc){
        this.loggerService.log("exception handled for add to album",exc)
      }
      
    }

    async getAllAlbumMetaData(albumType){
      try{
        return await this.fileOpsController.getAlbums(albumType);
      }catch(exc){
        this.loggerService.log("exception in fetchin album metadata",exc)
      }
    }

    async addToAlbumApi(){
      return new Promise(async (resolve, reject)=> {
        var addUrl = "";
        addUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG["commonUrls"]["albumDetails"] + '/' + this.universalService.selectedFile["boardKey"] + '/addition'
        try{
          this.universalService.showLoader = true;
          this.fileOperationsImplementation.setHandler(this.globalService)
          await this.fileOperationsImplementation.addtoAlbumApi(addUrl,this.addtoAlbumImplementatoin.paramsForAddingToAlbum);
          resolve(true);
        }catch(exc){
          reject(false);
          this.loggerService.log("exception for adding to album",exc)
      }})
    }

    async createAlbumAndAdd(albumName){

      return new Promise(async (resolve, reject)=> {
        try{
          this.universalService.showLoader = true;
          await this.fileOpsController.createAlbum(albumName);
          await this.addToAlbumApi();
          this.listService.noAlbumsPresent = false;
          resolve(true);
        } catch(exc){
          this.loggerService.log("exception for creating and adding to album",exc);
          reject(false);
        }
      })
    }
}
